import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { BeActivitiesAttributesModalRowData } from './be-activities-attributes-modal/be-activities-attributes-modal.model';

export type AgDeleteCellComponentParams =
  ICellRendererParams<BeActivitiesAttributesModalRowData> & {
    isDisabled?: (params: AgDeleteCellComponentParams) => null | string;
    onDelete: (params: AgDeleteCellComponentParams) => Promise<void>;
  };

@Component({
  imports: [IconComponent, NgClass, TooltipDirective],
  styles: [],
  template: `
    <div
      class="flex h-full w-[32px] items-center justify-center text-aux-error"
      (click)="onDelete()"
      [ngClass]="{
        'cursor-not-allowed opacity-50': disabled,
        'cursor-pointer': !disabled,
      }"
      [auxTooltip]="disabled ? tooltip : ''"
    >
      <aux-icon name="X" />
    </div>
  `,
})
export class AgDeleteCellComponent implements ICellRendererAngularComp {
  disabled = false;
  params!: AgDeleteCellComponentParams;
  tooltip = '';

  agInit(params: AgDeleteCellComponentParams): void {
    this.params = params;
    const resp = params.isDisabled ? params.isDisabled(this.params) : false;

    if (resp) {
      this.disabled = true;
      this.tooltip = resp;
    }
  }

  onDelete() {
    if (this.disabled) {
      return;
    }

    this.params.onDelete(this.params).catch(console.error);
  }

  refresh(): boolean {
    return false;
  }
}
